import React, { useEffect, useState } from 'react';
type Purchase = {
  name: string;
  city: string;
  product: string;
};
const NAMES = ['María F.', 'Valentina L.', 'Sofía R.', 'Carolina G.', 'Rocío M.', 'Sabrina C.', 'Paula A.', 'Camila P.', 'Agustina B.', 'Florencia T.', 'Luciana D.', 'Micaela S.', 'Antonella V.', 'Julieta N.', 'Belén O.', 'Yésica H.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Neuquén', 'Salta', 'San Juan', 'Bahía Blanca', 'Santa Fe', 'Resistencia', 'Posadas', 'Río Cuarto'];
const PRODUCTS = ['Kit Lashista', 'Kit + Lashista de Élite'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function randomMinutesAgo(): string {
  const m = Math.floor(Math.random() * 9) + 1;
  return `hace ${m} min`;
}
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [timeAgo, setTimeAgo] = useState('');
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let mounted = true;
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      if (!mounted) return;
      setPurchase({
        name: pick(NAMES),
        city: pick(CITIES),
        product: pick(PRODUCTS)
      });
      setTimeAgo(randomMinutesAgo());
      setVisible(true);
      hideTimer = setTimeout(() => {
        if (!mounted) return;
        setVisible(false);
        const delay = 40000 + Math.random() * 20000; // 40-60s
        nextTimer = setTimeout(show, delay);
      }, 6500);
    };
    // First popup appears after 8s
    nextTimer = setTimeout(show, 8000);
    return () => {
      mounted = false;
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  if (!purchase) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-[300px] sm:max-w-xs transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} role="status" aria-live="polite" data-id="element-61">
      <div className="bg-white border border-[#E8D5C4] rounded-2xl shadow-xl p-3 sm:p-4 flex items-center gap-3" data-id="element-62">
        <div className="relative shrink-0" data-id="element-63">
          <div className="w-10 h-10 rounded-full bg-[#FAF6F0] border border-[#E8D5C4] flex items-center justify-center text-[#5A2A3D] font-bold text-sm" data-id="element-64">
            {purchase.name.charAt(0)}
          </div>
          <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-green-500 border-2 border-white flex items-center justify-center" data-id="element-65">
            <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-66">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-67" />
            </svg>
          </div>
        </div>
        <div className="flex-1 min-w-0" data-id="element-68">
          <div className="text-[10px] uppercase tracking-wider text-[#B8956A] font-bold mb-0.5" data-id="element-69">
            ✓ Compra verificada
          </div>
          <div className="text-[#2D1A22] text-sm font-medium leading-tight truncate" data-id="element-70">
            {purchase.name} · {purchase.city}
          </div>
          <div className="text-[11px] text-[#5A4A4F] mt-0.5 truncate" data-id="element-71">
            Compró{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-72">{purchase.product}</span>
          </div>
          <div className="text-[10px] text-[#B8956A] mt-0.5" data-id="element-73">{timeAgo}</div>
        </div>
        <button onClick={() => setVisible(false)} aria-label="Cerrar" className="shrink-0 text-[#B8956A] hover:text-[#5A2A3D] text-lg leading-none p-1" data-id="element-74">
          ×
        </button>
      </div>
    </div>;
}